<template>
<div id="wrapper">
    <!-- SkipNav -->
    <div id="skipNav">
        <ul>
            <li><a href="#content" tabindex="0">본문 바로가기</a></li>
        </ul>
    </div>
    <!-- //SkipNav -->

    <!-- Header -->
    <Header ref="header"></Header>
    <!-- //Header -->

    <!-- 2025.04.29 송준형 : REQSDP-7193 - lgappstv.com 한국 웹접근성 심사결과 대응 2025년 -->
    <!-- 전체검색 -->
    <IntegratedSearch></IntegratedSearch>
    <!-- //전체검색 -->

    <!-- Container -->
    <div id="container" class="out-sec">
        <router-view />
    </div>
    <!-- //Container -->

    <!-- 챗봇 -->
    <aside class="float-wrap">
        <div id="chatbot" class="float-chatbot" v-show="cntryCode == 'KR' || cntryCode == 'US'">
            <!-- 2025.09.11 송준형 : REQSDP-8783 - [pcmall] 챗봇 URL 랜딩(리다이팅 검토) -->
            <template v-if="cntryCode == 'KR'">
                <a :href="chatBotUrl" target="_blank" class="btn-ico" :title="$t('gwa.alt.common.wa_title_4')">
					<span><i class="ico ico-chatbot">Chatbot</i></span>
                  <!--<button type="button" class="btn-ico" :title="$t('gwa.alt.common.wa_title_4')"><span><i class="ico ico-chatbot">Chatbot</i></span></button>-->
                </a>
            </template>
            <template v-else>
                <button type="button" class="btn-ico" @click="goChatbot()"><span><i class="ico ico-chatbot2">Chatbot</i></span></button>
            </template>
        </div>
        <div class="float-pageUp">
            <!-- REQSDP-10103 : 2026.03.09 송준형 - [pcmall] ru.lgappstv.com 러시아 자국어 강화법_영문 텍스트, 이미지 교체건 -->
            <button type="button" class="btn" :title="$t('gwa.alt.common.wa_title_60')"><span><i class="arw arw-up"></i><em v-if="cntryCode != 'RU'">Top</em></span></button>
        </div>
    </aside>
    <!-- //챗봇 -->

    <!-- Footer -->
    <Footer></Footer>
    <!-- //Footer -->

    <div id="pageLoading" class="loadingDim-wrap">
        <div class="loading"><img src="/img/cmn/loading.png" alt="로딩중"></div>
    </div>

    <!-- C20200615_50615 : 2020.06.23 송준형 START -->
    <!--<div>-->
        <!--<GAPop></GAPop>-->
    <!--</div>-->
    <!-- C20200615_50615 : 2020.06.23 송준형 START -->
</div>
</template>

<script>

    import qs from "qs";

    import Header from '@/components/nav/Header';
    import Footer from '@/components/nav/Footer';
    import IntegratedSearch from '@/components/integratedsearch/IntegratedSearch';
    import GAPop from "@/components/terms/GAPop";

	export default {
		name: "App",
		components: {
            Header,
            Footer,
            IntegratedSearch,
            GAPop
		},
		data() {
			return {
                isLogin: false,
                cntryCode : "",
                langCode : "", // REQSDP-1550 : 2022.04.12 송준형 - [PC webiste] 챗봇 URL 및 이미지변경 요청
                chatBotUrl : "" // REQSDP-8387 : 2025.09.11 송준형 - [pcmall] 챗봇 URL 랜딩(리다이팅 검토)
			}
        },
			computed: {

			},
			watch: {
				'$route': 'changeRoute'
			},
			mounted() {
				console.log('App.vue mounted..');

				var firstName = this.getCookie('firstName');
				var lastName = this.getCookie('lastName');
				if(firstName == null || lastName == null) {
					this.isLogin = false;
				} else {
					this.isLogin = true;
				}

                this.cntryCode = _domainCntryCode;
				this.langCode = _domainLangCode; // REQSDP-1550 : 2022.04.12 송준형 - [PC webiste] 챗봇 URL 및 이미지변경 요청

                // 2024.06.21 송준형 : REQSDP-5357 - PC Mall 웹접근성 심사결과대응 2차
                $("#searchAll").on("focus", function() {
                    if($(".search-combine").hasClass("is-closed")) { // WISEDEVREQ-130 : 2026.06.10 송준형 - [pcmall] 2026년 웹접근성 심사 대응
                        $("#container").focus();
                    }
                });

                // 2025.05.29 송준형 : REQSDP-7378 - lgappstv.com 한국 웹접근성 심사결과 대응 2025년 (잔여)
                $("#container").on("focusin", function() {
                  if($(".search-combine").hasClass("is-opened")) { // WISEDEVREQ-130 : 2026.06.10 송준형 - [pcmall] 2026년 웹접근성 심사 대응
                    $("#searchCloseBtn").focus();
                  }
                });

                // 2024.12.17 송준형 : REQSDP-6333 - PCMall LMP(멤버스) 로그인 연동 방식 개선 개발
                const pageShowEventHandler = (e) => {
                    var loginBackYn = "N";

                    if(e.persisted || (window.performance && window.performance.navigation.type == 2)) {
                        if(this.$store.state.loginYn == "Y") {
                            loginBackYn = "Y";
                        }
                    }

                    this.$store.state.loginYn = "N";
                    if(loginBackYn == "Y") {
                        this.$router.go(-1);
                    }
                };
                window.addEventListener('pageshow', pageShowEventHandler);

        // start-2025.09.11 송준형 : REQSDP-8387 - [pcmall] 챗봇 URL 랜딩(리다이팅 검토)
        const params = {
          cntryCode: this.cntryCode.toLowerCase(),
          langCode: this.langCode.toLowerCase()
        };

        this.$axios.post('/api/main/retrieveChatBotUrl.ajax', qs.stringify(params)).then((result) => {
          this.chatBotUrl = result.data.url;
        });
        // end-2025.09.11 송준형 : REQSDP-8387 - [pcmall] 챗봇 URL 랜딩(리다이팅 검토)
			},
		methods : {
			changeRoute(to, from) {
				console.log('Main.vue', 'changeRoute', to, from);
                console.log(this.$refs.header.changeMenu(to));
                
                // ui.searchAll.close('searchAll'); // 검색바 닫힘

                // 2021.02.05 송준형 : C20210205_77310 - PC Mall 코드 내 meta_name field 추가 요청드립니다.
                // 2025.11.13 송준형 : REQSDP-9056 - 정적 developer_url META tag 적용
                // 2026.01.13 송준형 : REQSDP-9211 - [pcmall]Developer URL 적용 위한 글로벌 앱 리스트 페이지 신규개발
                if($("meta[name='appstore:store_id']").attr("content") != "") {
                    $("meta[name='appstore:developer_url']").attr("content", "");
                    $("meta[name='appstore:bundle_id']").attr("content", "");
                    $("meta[name='appstore:store_id']").attr("content", "");
                }

                $("#wrapper").attr("tabindex", 0); // 2023.06.23 송준형 : REQSDP-2913 - [pcmall] PC website 웹접근성 심사 결과 대응_2023년
                $("#wrapper").focus(); // 2023.06.23 송준형 : REQSDP-2913 - [pcmall] PC website 웹접근성 심사 결과 대응_2023년

                if($(".dimmer-popup").length) { // 2024.06.13 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년
                    dimmer.close('dimmer-popup', 0.6);
                }
			},
            logout() {
                const vm = this;
                this.$axios.get('/api/main/logout.ajax').then((result) => {
                    console.log('document.cookie', document.cookie);
                    this.isLogin = false;
                })
            },
		    goChatbot() {
          var newWindow = window.open(this.chatBotUrl, "_blank", 'left=0, top=0, width=360, height=620, resizable=yes');
          newWindow.location.href = this.chatBotUrl;
            },
            goLgaccount() {
                // 2024.12.17 송준형 : REQSDP-6333 - PCMall LMP(멤버스) 로그인 연동 방식 개선 개발
                const r = { path : "/main/loginLink" };
                this.$router.push(r);
            },
		    retrieveFamilySite(event) {
                  if (event.target.value == "smartWorld") {
                      window.location.href = "http://www.lgworld.com/web.gateway.dev";
                  } else if (event.target.value == "sellerLounge") {
                      window.location.href = "http://seller.lgappstv.com/seller/main/Main.lge";
                  } else if (event.target.value == "developer") {
                      window.location.href = "http://webostv.developer.lge.com/";
                  }
		    },
            getCookie(cname) {
                var name = cname + "=";
                var decodedCookie = decodeURIComponent(document.cookie);
                var ca = decodedCookie.split(';');
                for(var i = 0; i <ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        var str = c.substring(name.length, c.length);
                        if(str === null || str === '') {
                            return null;
                        } else {
                            return str;
                        }
                    }
                }
                return null;
            }
		}
	};
</script>

<style>
</style>
